import Header from "./Component/Frame1/Header";
import Dreams from "./Component/Frame2/Dreams";
import OurTest from "./Component/Frame3/OurTest"
import Result from "./Component/Frame4/Result";
import Study from "./Component/Frame5/Study";
import Footer from "./Component/Frame6/Footer";

function App() {
  return (
   <>
   <Header/>
   <Dreams/>
   <OurTest/>
   <Result/>
   <Study/>
   <Footer/>
   </>
  );
}

export default App;
